{
  "notification.wallet_topup_confirmed": {
    "title": "Recharge confirmée",
    "body": "Votre portefeuille a été rechargé de {{amount}} {{currency}}. Nouveau solde : {{balance_after}} {{currency}}."
  },
  "notification.invoice_generated": {
    "title": "Nouvelle facture disponible",
    "body": "La facture {{invoice_number}} pour la période {{period_start}} – {{period_end}} d'un montant de {{total}} {{currency}} est prête à être téléchargée."
  },
  "notification.withdraw_approved": {
    "title": "Retrait approuvé",
    "body": "Votre demande de retrait {{request_id}} de {{amount}} {{currency}} a été approuvée et mise en file d'attente pour transfert."
  },
  "notification.wallet_low_balance": {
    "title": "Solde du portefeuille bas",
    "body": "Le solde de votre portefeuille est maintenant de {{balance}} {{currency}}, en dessous du seuil d'alerte de {{threshold}} {{currency}}. Rechargez pour maintenir le flux des commandes."
  },
  "notification.wallet_low_balance_test": {
    "title": "Alerte de test — solde du portefeuille bas",
    "body": "Ceci est une alerte de TEST. Le solde simulé serait de {{balance}} {{currency}} par rapport au seuil d'alerte de {{threshold}} {{currency}}. Aucune action requise."
  },
  "notification.new_topup_request": {
    "title": "Nouvelle demande de recharge",
    "body": "Le marchand {{merchant_name}} a soumis une demande de recharge {{request_id}} de {{amount}} {{currency}} via {{method}}."
  },
  "notification.new_withdraw_request": {
    "title": "Nouvelle demande de retrait",
    "body": "Le marchand {{merchant_name}} a soumis une demande de retrait {{request_id}} de {{amount}} {{currency}}."
  },
  "notification.pending_request_reminder": {
    "title": "Rappel de demandes en attente",
    "body": "{{count}} demande(s) sont en attente depuis plus de {{hours}} heures. Veuillez les examiner."
  },
  "notification.merchant_credit_overdue": {
    "title": "Crédit marchand en retard",
    "body": "Le marchand {{merchant_name}} a un solde en retard de {{amount}} {{currency}}, en retard de {{days_overdue}} jour(s)."
  },
  "notification.imap_fail": {
    "title": "Échec du sondage IMAP",
    "body": "Le lecteur IMAP bancaire {{account}} a échoué : {{error}}. Dernier sondage réussi à {{last_success_at}}."
  },
  "notification.bullmq_dlq_alert": {
    "title": "Tâche déplacée vers la DLQ",
    "body": "La file {{queue}} a envoyé la tâche {{job_id}} vers la file des messages morts après {{attempts}} tentatives. Raison : {{reason}}."
  },
  "notification.auto_recharge_fail": {
    "title": "Échec de la recharge automatique",
    "body": "La recharge automatique pour le marchand {{merchant_name}} de {{amount}} {{currency}} a échoué : {{reason}}. Solde du portefeuille : {{balance}} {{currency}}."
  },
  "notification.auto_pay_batch": {
    "title": "Lot de paiement automatique traité",
    "body": "Le lot de paiement automatique {{batch_id}} a traité {{success_count}}/{{total_count}} factures pour un total de {{total}} {{currency}}. {{failed_count}} échecs."
  },
  "notification.invoice_sent": {
    "title": "Nouvelle facture émise",
    "body": "La facture {{invoice_number}} ({{amount}} {{currency}}) a été émise. Veuillez la vérifier et la régler à temps."
  },
  "notification.invoice_paid": {
    "title": "Facture payée",
    "body": "La facture {{invoice_number}} a été payée {{amount}} {{currency}}. Merci."
  },
  "notification.invoice_payment_submitted": {
    "title": "Nouveau paiement en attente d'approbation",
    "body": "Un marchand a soumis un paiement de {{amount}} {{currency}} pour la facture {{invoice_number}} via {{gateway}}. Ouvrez la file comptable pour approuver ou rejeter."
  },
  "notification.invoice_payment_rejected": {
    "title": "Paiement rejeté",
    "body": "Le paiement de {{amount}} {{currency}} pour la facture {{invoice_number}} a été rejeté. Raison : {{reason}}. Veuillez vérifier et soumettre à nouveau une preuve de paiement valide."
  },
  "notification.credit_memo_issued": {
    "title": "Nouvel avoir émis",
    "body": "Vous avez reçu un avoir d'une valeur de {{amount}} USD. Le solde peut être imputé sur votre prochaine facture."
  },
  "notification.invoice_overdue": {
    "title": "Facture en retard de {{days}} jour(s)",
    "body": "La facture {{invoice_number}} est en retard de {{days}} jour(s) (échéance : {{due_date}}). Solde restant : {{amount}} {{currency}}. Veuillez payer rapidement pour éviter les restrictions sur les nouvelles commandes."
  },
  "notification.invoice_overdue_final": {
    "title": "Facture en retard de 7 jours — dernier avertissement",
    "body": "La facture {{invoice_number}} est en retard de {{days}} jour(s) (échéance : {{due_date}}). Solde restant : {{amount}} {{currency}}. Veuillez payer rapidement pour éviter les restrictions sur les nouvelles commandes."
  },
  "notification.credit_expiry_7d": {
    "title": "Votre crédit expire dans 7 jours",
    "body": "Votre crédit actuel expire dans 7 jours. Veuillez régler le solde impayé avant l'échéance pour éviter le blocage automatique de la carte."
  },
  "notification.credit_expiry_1d": {
    "title": "Le crédit expire demain",
    "body": "Votre crédit actuel expire dans les prochaines 24 heures. Ceci est le dernier rappel — veuillez régler le solde impayé aujourd'hui."
  },
  "notification.credit_remind_at_amount": {
    "title": "Vous avez atteint le seuil de crédit configuré",
    "body": "Vous avez utilisé {{used}} sur votre limite de {{limit}}, atteignant le seuil de rappel {{threshold}} que vous avez configuré."
  },
  "notification.credit_sweep_applied": {
    "title": "Prélèvement automatique de crédit",
    "body": "{{amount}} a été déduit de votre portefeuille pour rembourser automatiquement la dette de crédit."
  },
  "notification.crm_attachment_infected": {
    "title": "Pièce jointe détectée comme malveillante",
    "body": "Le fichier \"{{filename}}\" a été mis en quarantaine. Signature : {{signature}}."
  },
  "notification.order_assigned": {
    "title": "Nouvelle commande attribuée",
    "body": "La commande {{order_code}} vous a été attribuée — ouvrez {{link}} pour la traiter."
  },
  "notification.order_paid": {
    "title": "Commande payée",
    "body": "La commande {{order_code}} vient d'être payée."
  },
  "notification.order_shipped": {
    "title": "Commande expédiée",
    "body": "La commande {{order_code}} a été remise au transporteur."
  },
  "notification.order_delivered": {
    "title": "Commande livrée",
    "body": "La commande {{order_code}} est arrivée chez le client."
  },
  "notification.order_cancelled": {
    "title": "Commande annulée",
    "body": "La commande {{order_code}} a été annulée."
  },
  "notification.order_qc_failed": {
    "title": "Contrôle qualité refusé",
    "body": "Le vendeur a signalé un problème qualité sur la commande {{order_code}}."
  },
  "notification.order_qc_passed": {
    "title": "Contrôle qualité validé",
    "body": "La commande {{order_code}} a passé le contrôle qualité."
  },
  "notification.order_unpaid_autocancelled": {
    "title": "Commande annulée automatiquement — impayée",
    "body": "La commande #{{order_id}} a été annulée automatiquement après {{hours}} heures sans paiement. Le montant réservé a été recrédité sur votre portefeuille. Veuillez recréer la commande si nécessaire."
  },
  "notification.tracking_rts_detected": {
    "title": "Colis retourné à l'expéditeur",
    "body": "La commande #{{order_id}} a été retournée à l'expéditeur par le transporteur (suivi {{tracking_number}}). {{item_count}} article(s) concerné(s) — à vérifier et traiter."
  },
  "notification.order_waiting": {
    "title": "Commande en attente de votre approbation",
    "body": "La commande {{orderNumber}} attend votre approbation avant d'être envoyée en production. Vérifiez-la et envoyez-la lorsque vous êtes prêt."
  },
  "notification.order_auto_pushed": {
    "title": "Commande envoyée en production",
    "body": "La commande {{orderNumber}} a été automatiquement envoyée en production."
  },
  "notification.order_admin_sent": {
    "title": "Commande envoyée en production par le support",
    "body": "La commande {{orderNumber}} a été envoyée en production en votre nom par notre équipe de support."
  },
  "notification.product_published": {
    "title": "Produit publié",
    "body": "Le produit {{product_name}} a été publié."
  },
  "notification.product_approved": {
    "title": "Produit approuvé",
    "body": "Le produit « {{product_name}} » a été approuvé par l'administrateur et est maintenant en ligne."
  },
  "notification.product_rejected": {
    "title": "Produit rejeté",
    "body": "Le produit « {{product_name}} » a été rejeté par l'administrateur. Raison : {{reason}}"
  },
  "notification.product_sync_failed": {
    "title": "Échec de synchronisation du produit",
    "body": "Le produit {{product_name}} n'a pas pu être synchronisé vers {{store}}."
  },
  "notification.product_archived": {
    "title": "Produit archivé",
    "body": "Le produit {{product_name}} a été archivé."
  },
  "notification.store_connected": {
    "title": "Boutique connectée",
    "body": "La boutique {{store}} {{store_name}} est connectée."
  },
  "notification.store_disconnected": {
    "title": "Boutique déconnectée",
    "body": "La boutique {{store}} {{store_name}} nécessite une ré-authentification."
  },
  "notification.store_sync_started": {
    "title": "Synchronisation démarrée",
    "body": "Synchronisation de {{count}} produits vers {{store}}."
  },
  "notification.store_sync_completed": {
    "title": "Synchronisation terminée",
    "body": "Synchronisation {{store}} terminée — {{count}} produits."
  },
  "notification.wallet_charged": {
    "title": "Portefeuille débité",
    "body": "La commande {{order_code}} a débité {{amount}} de votre portefeuille."
  },
  "notification.wallet_payout_sent": {
    "title": "Paiement envoyé",
    "body": "Le versement {{payout_code}} a réussi : {{amount}}."
  },
  "notification.payout_available": {
    "title": "Gains disponibles au retrait",
    "body": "Vous avez {{amount}} disponibles au retrait — visitez {{link}}."
  },
  "notification.auto_pay_retry_exhausted": {
    "title": "Paiement automatique suspendu",
    "body": "Le système a tenté le paiement automatique plusieurs fois sans succès. La commande reste en attente de paiement. Veuillez recharger votre portefeuille ou payer manuellement."
  },
  "notification.auto_recharge_disabled": {
    "title": "Rechargement automatique suspendu",
    "body": "Le système a tenté le rechargement automatique 3 fois (1 h / 6 h / 24 h) sans succès. Le rechargement automatique a été désactivé — vérifiez votre moyen de paiement lié et réactivez-le manuellement."
  },
  "notification.invoice_due": {
    "title": "Facture bientôt due",
    "body": "La facture {{invoice_number}} arrive à échéance dans {{days}} jour(s)."
  },
  "notification.refund_issued": {
    "title": "Remboursement de facture",
    "body": "Le remboursement de {{amount}} pour la facture {{invoice_number}} a été traité."
  },
  "notification.system_maintenance": {
    "title": "Maintenance planifiée",
    "body": "Maintenance à {{time}} — indisponibilité prévue {{duration}}."
  },
  "notification.system_release": {
    "title": "Nouvelle version publiée",
    "body": "{{product}} {{version}} est en ligne — consultez le changelog."
  },
  "notification.security_alert": {
    "title": "Alerte de sécurité",
    "body": "Une nouvelle connexion depuis un appareil inconnu a été détectée."
  },
  "notification.kyc_update": {
    "title": "Profil KYC à mettre à jour",
    "body": "Votre pièce d'identité expire dans {{days}} jours."
  },
  "notification.support_ticket_assigned": {
    "title": "Nouveau ticket de support attribué",
    "body": "Le ticket {{ticketNumber}} ({{category}}) vous a été attribué — ouvrez-le pour répondre."
  },
  "notification.support_ticket_force_reassigned": {
    "title": "Ticket de support réattribué",
    "body": "Le ticket {{ticketNumber}} ({{category}}) a été renvoyé dans la file non attribuée et nécessite un nouveau responsable."
  },
  "notification.support_ticket_resolved": {
    "title": "Votre ticket de support a été résolu",
    "body": "Le ticket {{ticketNumber}} — {{subject}} a été résolu. Ouvrez le Support pour vérifier ou rouvrir."
  },
  "notification.support_ticket_opened_by_admin": {
    "title": "Le support a ouvert un ticket pour vous",
    "body": "Ticket {{ticketNumber}} — {{subject}}. Ouvrez le Support pour suivre."
  },
  "notification.support_ticket_reply": {
    "title": "Nouvelle réponse au support : {{subject}}",
    "body": "{{preview}}"
  },
  "notification.support_ticket_reply_no_subject": {
    "title": "Nouvelle réponse au support",
    "body": "{{preview}}"
  },
  "notification.support_ticket_created_for_desk": {
    "title": "Nouveau ticket #{{ticketNumber}} : {{subject}}",
    "body": "{{merchantName}} a ouvert un ticket {{category}}. {{preview}}"
  },
  "notification.support_ticket_merchant_reply": {
    "title": "Le marchand a répondu au #{{ticketNumber}} : {{subject}}",
    "body": "{{merchantName}} : {{preview}}"
  },
  "notification.member_landed_no_team": {
    "title": "Un nouveau membre a rejoint sans équipe",
    "body": "{{member_name}} a accepté l'invitation, mais l'équipe à laquelle il était invité a été désactivée — il n'appartient actuellement à aucune équipe. Veuillez lui attribuer une équipe."
  },
  "notification.uat_sample": {
    "title": "[UAT] Notification d'exemple n°{{n}} ({{category}})",
    "body": "Fixture UAT — notification {{category}} n°{{n}} pour tester la liste/pagination/badge non lu."
  },
  "support.channel.down": {
    "title": "Canal de support hors service",
    "body": "Le canal {{platform}} « {{name}} » est déconnecté et ne peut plus recevoir de messages. Reconnectez-le dans les Configurations de support."
  },
  "support.bridge.offline": {
    "title": "Passerelle hors ligne",
    "body": "La passerelle {{platform}} « {{name}} » est hors ligne ({{reason}}) et ne peut plus envoyer ni recevoir de messages. Ré-authentifiez la passerelle pour la rétablir."
  },
  "support.channel.zalo_refresh_failed": {
    "title": "Échec du rafraîchissement du jeton Zalo",
    "body": "Le rafraîchissement automatique du jeton pour le canal Zalo « {{name}} » a échoué après {{attempts}} tentative(s) : {{reason}}. Reconnectez le canal pour rétablir la distribution."
  },
  "support.ticket.reopened_by_merchant": {
    "title": "Le marchand a rouvert un ticket",
    "body": "Le marchand a rouvert le ticket {{ticketNumber}}."
  },
  "support.ticket.closed_by_merchant": {
    "title": "Le marchand a confirmé la clôture du ticket",
    "body": "Le marchand a confirmé la clôture du ticket {{ticketNumber}}."
  },
  "support.dispatch.created": {
    "title": "Nouvelle demande de traitement",
    "body": "Vous avez une nouvelle demande de traitement (dispatch) à prendre en charge."
  },
  "support.dispatch.handler_reply": {
    "title": "Réponse du service de traitement",
    "body": "Le service de traitement a publié un message dans le dispatch du ticket {{ticketNumber}}."
  },
  "support.dispatch.returned": {
    "title": "Dispatch retourné",
    "body": "Le service de traitement a renvoyé les résultats pour le ticket {{ticketNumber}} — veuillez vérifier et clôturer avec le marchand."
  },
  "support.dispatch.vendor_reply": {
    "title": "Réponse du vendeur",
    "body": "Le vendeur a publié un message dans le dispatch du ticket {{ticketNumber}}."
  },
  "notification.support_ticket_rated": {
    "title": "Ticket noté {{rating}}/5",
    "body": "Le ticket {{ticketNumber}} ({{category}}) a reçu une note de {{rating}}/5 du marchand."
  },
  "notification.support_ticket_rated_low": {
    "title": "Alerte note basse : {{rating}}/5",
    "body": "Le ticket {{ticketNumber}} ({{category}}) a reçu une note basse ({{rating}}/5) — vérifiez la conversation et faites un suivi."
  },
  "notification.support_ticket_resolved_rate": {
    "title": "Votre ticket a été résolu",
    "body": "Le ticket {{ticketNumber}} ({{category}}) est résolu — évaluez le support que vous avez reçu."
  },
  "notification.order_waiting_sla_reminder": {
    "title": "Commande en attente de votre approbation",
    "body": "La commande {{order_code}} attend votre approbation depuis {{minutes}} minute(s). Vérifiez-la et envoyez-la en production."
  },
  "vendor_allocation.proposal.created": {
    "title": "Nouvelle proposition de changement d'allocation",
    "body": "{{proposer}} a proposé un changement d'allocation de vendeur en attente d'approbation. Motif : {{reason}}"
  },
  "vendor_allocation.proposal.approved": {
    "title": "Proposition d'allocation approuvée",
    "body": "Votre proposition de changement d'allocation de vendeur a été approuvée par {{approver}} et appliquée au blueprint."
  },
  "vendor_allocation.proposal.rejected": {
    "title": "Proposition d'allocation rejetée",
    "body": "Votre proposition de changement d'allocation de vendeur a été rejetée par {{approver}}. Motif : {{reason}}"
  },
  "notification.emb_fee_awaiting_accept": {
    "title": "Frais de broderie en attente d'approbation",
    "body": "La commande {{orderNumber}} comporte des frais de broderie de {{embFee}} en attente de votre approbation. Répondez avant le {{deadline}}."
  },
  "notification.emb_order_autocancelled_refund": {
    "title": "Commande auto-annulée et remboursée",
    "body": "La commande {{orderNumber}} a été auto-annulée après l'expiration du délai d'approbation des frais de broderie. {{refundAmount}} a été remboursé sur votre portefeuille."
  },
  "notification.pricing_profile_changed": {
    "title": "Profil tarifaire modifié",
    "body": "Votre compte a été déplacé de {{fromProfile}} vers {{toProfile}}. L'étiquette est purement informative et ne modifie pas votre formule de prix."
  },
  "notification.admin_surcharge_debited": {
    "title": "Surcoût d'ajustement débité du portefeuille",
    "body": "Commande {{orderNumber}} : {{amount}} a été débité — motif : {{reason}}."
  },
  "notification.order_confirmed_charged": {
    "title": "Commande confirmée",
    "body": "La commande {{orderNumber}} est confirmée et {{amount}} ont été débités de votre solde (taxes et livraison incluses)."
  },
  "notification.order_created": {
    "title": "Commande créée",
    "body": "La commande {{order_code}} a été créée."
  },
  "notification.order_charge_failed": {
    "title": "Échec du prélèvement de la commande",
    "body": "Le prélèvement de la commande {{order_code}} a échoué. Veuillez vérifier votre moyen de paiement et réessayer."
  },
  "notification.order_in_production": {
    "title": "Commande en production",
    "body": "La commande {{order_code}} est maintenant en production."
  },
  "notification.refund_failed": {
    "title": "Échec du remboursement",
    "body": "Le remboursement de la commande {{order_code}} n'a pas pu être traité. Notre équipe examine le problème."
  },
  "notification.dispute_opened": {
    "title": "Litige ouvert",
    "body": "Un litige a été ouvert pour la commande {{order_code}}. Veuillez l'examiner et répondre."
  },
  "notification.dispute_evidence_required": {
    "title": "Preuves de litige requises",
    "body": "Des preuves sont requises pour le litige de la commande {{order_code}} avant le {{deadline}}."
  },
  "notification.dispute_resolved_refund": {
    "title": "Litige résolu — remboursement",
    "body": "Le litige de la commande {{order_code}} a été résolu par un remboursement."
  },
  "notification.dispute_resolved_resend": {
    "title": "Litige résolu — réexpédition",
    "body": "Le litige de la commande {{order_code}} a été résolu par un envoi de remplacement."
  },
  "notification.dispute_resolved_rejected": {
    "title": "Litige résolu — rejeté",
    "body": "Le litige de la commande {{order_code}} a été examiné et rejeté."
  },
  "notification.label_purchased": {
    "title": "Étiquette d'expédition achetée",
    "body": "Une étiquette d'expédition a été achetée pour la commande {{order_code}} (suivi {{tracking_number}})."
  },
  "notification.label_void_failed": {
    "title": "Échec de l'annulation de l'étiquette",
    "body": "L'annulation de l'étiquette d'expédition de la commande {{order_code}} a échoué."
  },
  "notification.label_rebuy_required": {
    "title": "L'étiquette d'expédition doit être rachetée",
    "body": "L'étiquette d'expédition de la commande {{order_code}} doit être achetée à nouveau."
  },
  "notification.label_tracking_stalled": {
    "title": "Suivi bloqué",
    "body": "Le suivi de la commande {{order_code}} ({{tracking_number}}) n'a pas été mis à jour récemment."
  },
  "notification.embroidery_step2_reminder_24h": {
    "title": "Rappel des frais de broderie",
    "body": "La commande {{orderNumber}} a encore des frais de broderie en attente de votre approbation — ils expirent dans 24 heures."
  },
  "notification.address_change_requested": {
    "title": "Changement d'adresse demandé",
    "body": "Un changement d'adresse de livraison a été demandé pour la commande {{order_code}}."
  },
  "notification.address_change_confirmed": {
    "title": "Changement d'adresse confirmé",
    "body": "L'adresse de livraison de la commande {{order_code}} a été mise à jour."
  },
  "notification.address_change_expired": {
    "title": "Changement d'adresse expiré",
    "body": "Le délai de changement d'adresse pour la commande {{order_code}} a expiré sans confirmation."
  },
  "notification.vendor_rating_dropped": {
    "title": "Note du fournisseur en baisse",
    "body": "La note de performance du fournisseur {{vendor_name}} est passée sous le seuil."
  },
  "notification.vendor_assignment_revoked": {
    "title": "Affectation révoquée",
    "body": "L'affectation de la commande {{order_code}} a été révoquée."
  },
  "notification.vendor_quality_warning": {
    "title": "Avertissement qualité",
    "body": "Un avertissement qualité a été émis pour le fournisseur {{vendor_name}}."
  },
  "notification.webhook_delivery_exhausted_financial": {
    "title": "Échec de la livraison du webhook",
    "body": "Un webhook financier vers {{endpoint}} a épuisé toutes les tentatives et n'a pas été livré."
  },
  "notification.webhook_subscription_disabled": {
    "title": "Abonnement webhook désactivé",
    "body": "L'abonnement webhook {{endpoint}} a été désactivé après plusieurs échecs de livraison."
  },
  "notification.artwork_ingest_error": {
    "title": "Échec de la validation du visuel",
    "body": "La commande {{order_id}} présente un problème de visuel dans la zone {{area}} ({{error_code}}). Veuillez vérifier et téléverser à nouveau."
  },
  "notification.affiliate_payout_completed": {
    "title": "Mise à jour du paiement d'affiliation",
    "body": "Une mise à jour concernant votre paiement d'affiliation {{payout_id}} est disponible."
  },
  "notification.vendor_reassignment_needed": {
    "title": "Affectation fournisseur à traiter",
    "body": "La commande {{order_code}} n'a pas pu être affectée automatiquement ({{reason}}) — réaffectation manuelle requise."
  },
  "notification.account_suspended": {
    "title": "Compte suspendu",
    "body": "Votre compte a été suspendu. Motif : {{reason}}. Contactez le support si vous pensez qu'il s'agit d'une erreur."
  },
  "notification.account_reactivated": {
    "title": "Compte réactivé",
    "body": "Votre compte a été réactivé. Vous pouvez vous reconnecter et reprendre vos activités normalement."
  },
  "notification.blueprint_updated": {
    "title": "Blueprint mis à jour",
    "body": "Un blueprint que vous utilisez a été mis à jour. Veuillez vérifier et republier les produits concernés si nécessaire."
  },
  "notification.deal_expiry_warning": {
    "title": "Offre bientôt expirée",
    "body": "L'offre « {{deal_name}} » expirera dans {{days}} jour(s)."
  },
  "notification.embroidery_stitch_count_failed": {
    "title": "Échec du comptage des points de broderie",
    "body": "Commande {{order_id}}, article {{item_id}} : le service de comptage des points a échoué après toutes les tentatives. Vérification manuelle requise."
  },
  "notification.invoice_generation_failed": {
    "title": "Échec de la génération de la facture",
    "body": "Nous n'avons pas pu générer votre facture pour la période commençant le {{period_start}}. Notre équipe a été informée et réessaiera."
  },
  "notification.routing_pool_empty_merchant_rule": {
    "title": "Une règle de routage marchand a vidé le pool de vendeurs",
    "body": "Une règle de routage de {{merchantName}} ne laisse aucun vendeur éligible pour {{variantLabel}} ({{blueprintName}}). {{orderCount}} commande(s) sont en attente à cause de cela. Vérifiez les règles de routage de ce marchand pour les débloquer."
  },
  "notification.vendor_webhook_delivery_failed": {
    "title": "Échec de livraison du webhook",
    "body": "Impossible de livrer l'événement {{eventType}} à {{endpoint}} pour {{vendorName}} après {{attempts}} tentatives. La commande reste attribuée au vendeur — rien n'a été réattribué. Les événements ne sont jamais rejoués individuellement : appelez GET /assignments et GET /events pour vous remettre à jour."
  },
  "notification.vendor_webhook_auto_disabled": {
    "title": "Endpoint webhook désactivé automatiquement",
    "body": "L'endpoint webhook {{endpoint}} de {{vendorName}} a été désactivé automatiquement après {{failureCount}} événements consécutifs dont toutes les tentatives de livraison ont échoué. Plus aucun événement n'est envoyé. Relancez la vérification (handshake) sur la page Integration pour le réactiver, puis appelez GET /assignments et GET /events pour vous remettre à jour."
  },
  "notification.vendor_integration_key_revoked": {
    "title": "Clé API révoquée",
    "body": "La clé API {{keyPrefix}} de {{vendorName}} a été révoquée. Toute requête qui l'utilise encore renvoie désormais 401. Créez une nouvelle clé sur la page Integration si l'intégration est toujours utilisée."
  },
  "notification.vendor_integration_disabled_by_admin": {
    "title": "Intégration API désactivée par un administrateur",
    "body": "{{actor}} a désactivé l'intégration API de {{vendorName}}. Toutes les clés API de ce vendeur renvoient désormais 401 et aucun événement webhook n'est envoyé tant qu'un administrateur ne la réactive pas."
  },
  "_vgBindingP18": {
    "title": "vg-binding: P18.D-04 / vg-binding: P18.D-13 / vg-binding: P18.D-36",
    "body": "vg-binding: CONTEXT:decisions=P18.D-04,P18.D-13,P18.D-36 — phase 18 task-06 vendor Integration API notification rows (webhook delivery failed / endpoint auto-disabled / API key revoked / integration disabled by admin), added to en+vi+fr together because assertCatalogComplete() fails the build on a missing locale and tests run I18N_NOTIF_GUARD=strict (a fanout without an i18n_key throws). Not a notification key: absent from NOTIFICATION_KEYS, so lookup() never resolves it."
  },
  "_vgBinding": {
    "title": "vg-binding: CONTEXT:decisions=P17.D-04,P17.D-31,P17.D-43,P17.D-44",
    "body": "vg-binding: INTERFACE-STANDARDS:error-shape — phase 17 task-47 pool-empty admin notification catalog entry, added to en/vi/fr together (assertCatalogComplete fails the build on a missing locale). Not a notification key: absent from NOTIFICATION_KEYS, so lookup() never resolves it."
  }
}
